import { buildUrl } from "../../../common/urlBuilder";
import Service from "../../../service";

export const getHotelList = async (filteredData) => {
  let url = buildUrl("v1/hotel-management/hotel/pagination");
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getCustomerLists = async (filteredData) => {
  let url = buildUrl("v1/site-management/customer/pagination");
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getTravelAgentLists = async (filteredData) => {
  let url = buildUrl("v1/site-management/travel-partners");
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getAllRoomRate = async (filteredData) => {
  let url = buildUrl('v1/room-rate');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const createReservation = async (data) => {
  let url = buildUrl('v1/reservation-management/reservation');

  return Service.post(url, data);
};

export const updateReservation = async (data, id) => {
  let url = buildUrl(`v1/reservation-management/reservation/${id}`);

  return Service.put(url, data);
};

export const getAllReservation = async (filteredData) => {
  let url = buildUrl(`v1/reservation-management/reservation/pagination`);
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getReservationsLists = async (filteredData) => {
  let url = buildUrl(`v1/reservation-management/reservation`);
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getReservationDetails = async (id) => {
  let url = buildUrl(`v1/reservation-management/reservation/${id}`);

  return Service.get(url);
};

export const getReservationDetailsByBookingId = async (bookingId) => {
  let url = buildUrl(`v1/reservation-management/reservation/booking/${bookingId}`);

  return Service.get(url);
};

export const sendReservationInvoice = async (id) => {
  const url = buildUrl(`v1/reservation-management/reservation/${id}/send-invoice`);
  return Service.post(url);
};

export const confirmReservation = async (id) => {
  let url = buildUrl(`v1/reservation-management/reservation/${id}/confirm`);

  return Service.put(url);
};

export const sendReservationEmails = async (id, payload) => {
  let url = buildUrl(`v1/reservation-management/reservation/${id}/send-emails`);
  return Service.post(url, payload);
};

export const downloadReservationReport = async (filteredData) => {
  let url = buildUrl(`v1/reservation-management/reservation/download-report`);
  if (filteredData) url += `?${filteredData}`;

  return Service.custom({
    url,
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    },
    responseType: 'blob'
  });
};